export const FIELD_COULD_NOT_BE_EMPTY = "Field '###' could not be empty";
